// The episode page reads ?timestamp= (whole seconds); preserve any existing query params.
export function withTimestamp(url, timestamp) {
  if (!(timestamp > 0)) return url;
  const target = new URL(url, window.location.origin);
  target.searchParams.set("timestamp", Math.floor(timestamp));
  return target.toString();
}
